<mat-accordion multi>
  @for (alertsPerDevice of filteredAlertList; track alertsPerDevice.deviceId) {
    @if ((alertsPerDevice.alertDetails?.length ?? 0) > 0) {
      <mat-expansion-panel
        [id]="alertsPerDevice.deviceName || alertsPerDevice.deviceId"
      >
        <!-- 一つのアラートのサマリ -->
        <mat-expansion-panel-header
          class="!tw-h-full"
          [ngClass]="{
            '!tw-bg-red-300': isAlert(alertsPerDevice),
            '!tw-bg-yellow-300': !isAlert(alertsPerDevice),
          }"
        >
          <mat-panel-title class="tw-text-xl">
            <mat-icon class="tw-text-3xl !tw-w-9 !tw-h-9">report</mat-icon>
            <a
              [routerLink]="['/device-info', alertsPerDevice.deviceId]"
              [queryParams]="{ page: 'dashboard' }"
              class="tw-max-w-56 tw-truncate"
            >
              {{ alertsPerDevice.deviceName || alertsPerDevice.deviceId }}
            </a>
          </mat-panel-title>
          <mat-panel-description>
            <div class="tw-flex tw-w-full tw-h-14 tw-items-center">
              @if (isEventAlert(alertsPerDevice.deviceId)) {
                <div class="tw-w-full">
                  アラート：
                  {{ deviceAlertCount(alertsPerDevice.deviceId, "alert") }}
                </div>
              } @else if (selectedSensingType === "tilt") {
                <div class="tw-w-full">
                  上限アラート：
                  {{ deviceAlertCount(alertsPerDevice.deviceId, "alertMax") }}
                </div>
              } @else {
                <div class="tw-flex-col tw-w-full">
                  <div>
                    上限アラート：
                    {{ deviceAlertCount(alertsPerDevice.deviceId, "alertMax") }}
                  </div>
                  <div>
                    下限アラート：
                    {{ deviceAlertCount(alertsPerDevice.deviceId, "alertMin") }}
                  </div>
                </div>
                <div class="tw-flex-col tw-w-full">
                  <div *ngIf="!isSensor(selectedSensingType)">
                    ワーニング：
                    {{
                      deviceAlertCount(alertsPerDevice.deviceId, "prealertMax")
                    }}
                  </div>
                  <div *ngIf="!isSensor(selectedSensingType)">
                    ワーニング：
                    {{
                      deviceAlertCount(alertsPerDevice.deviceId, "prealertMin")
                    }}
                  </div>
                </div>
              }

              <div class="tw-flex-col tw-w-full">
                <span> 最新発生日時: </span>
                <div>
                  {{
                    alertsPerDevice.latestEventAt | date: "yyyy/MM/dd HH:mm:ss"
                  }}
                </div>
              </div>
            </div>
          </mat-panel-description>
        </mat-expansion-panel-header>

        <!-- アラート一覧のアコーディオン -->
        @for (alert of alertsPerDevice.alertDetails; track alert.eventAt) {
          <div [id]="alert.eventAt">
            <!-- アラートの場合 -->
            @if (
              alert.status === "AlertMax" ||
              alert.status === "AlertMin" ||
              alert.status === "Alert"
            ) {
              <button
                class="tw-w-full tw-border-0 tw-bg-red-100"
                [ngClass]="{
                  'tw-font-bold tw-text-red-600': isSelectedAlert(alert),
                }"
                (mouseenter)="onMouseEnter($event)"
                (mouseleave)="onMouseLeave($event)"
                (click)="
                  selectedAlert(
                    alert,
                    alertsPerDevice.deviceName,
                    alertsPerDevice.deviceId
                  )
                "
              >
                <div class="tw-flex tw-items-center tw-h-12 tw-ml-8">
                  <div>
                    <mat-icon>error</mat-icon>
                  </div>
                  <div
                    class="tw-flex tw-items-center tw-w-ful tw-justify-start"
                  >
                    @if (alert.status === "AlertMax") {
                      <div class="tw-w-32">上限アラート:</div>
                      <div class="tw-w-32">
                        {{ alert.value | numeral: "0.0" }} {{ unit }}
                      </div>
                      <div class="tw-w-40">
                        （上限 {{ alert.threshold | numeral: "0.0" }}
                        {{ unit }}）
                      </div>
                    } @else if (alert.status === "AlertMin") {
                      <div class="tw-w-32">下限アラート:</div>
                      <div class="tw-w-32">
                        {{ alert.value | numeral: "0.0" }} {{ unit }}
                      </div>
                      <div class="tw-w-40">
                        （下限 {{ alert.threshold | numeral: "0.0" }}
                        {{ unit }}）
                      </div>
                    } @else if (selectedSensingType === "fallDetected") {
                      <div class="tw-w-32">落下検知</div>
                      <div class="tw-w-24"></div>
                      <div class="tw-w-32"></div>
                    } @else if (selectedSensingType === "mcdDetected") {
                      @if (alert.eventTrigger === "InMotionToStationary") {
                        <div class="tw-w-32">動 → 静 検知</div>
                      } @else if (
                        alert.eventTrigger === "StationaryToInMotion"
                      ) {
                        <div class="tw-w-32">静 → 動 検知</div>
                      }
                      <div class="tw-w-24"></div>
                      <div class="tw-w-32"></div>
                    } @else if (selectedSensingType === "shockDetected") {
                      <div class="tw-w-10"></div>
                      <div class="tw-w-32 tw-text-left">
                        衝撃検知（{{ alert.threshold ?? "-" }}
                        G）
                      </div>
                      <div class="tw-w-4"></div>
                      <div class="tw-w-32"></div>
                    } @else if (selectedSensingType === "lightExposure") {
                      @if (alert.eventType === "LightToDark") {
                        <div class="tw-w-10"></div>
                        <div class="tw-w-44 tw-text-left">
                          明 → 暗 検出（{{ alert.value ?? "-" }}
                          Lux）
                        </div>
                        <div class="tw-w-2"></div>
                        <div class="tw-w-32"></div>
                      } @else if (alert.eventType === "DarkToLight") {
                        <div class="tw-w-10"></div>
                        <div class="tw-w-44 tw-text-left">
                          暗 → 明 検出（{{ alert.value ?? "-" }}
                          Lux）
                        </div>
                        <div class="tw-w-2"></div>
                        <div class="tw-w-32"></div>
                      } @else if (alert.eventType === "LightTooBright") {
                        <div class="tw-w-10"></div>
                        <div class="tw-w-44 tw-text-left">
                          明暗設定失敗（{{ alert.value ?? "-" }}
                          Lux）
                        </div>
                        <div class="tw-w-2"></div>
                        <div class="tw-w-32"></div>
                      } @else if (
                        alert.eventType === "OneTimeLightExposureDetected"
                      ) {
                        <div class="tw-w-10"></div>
                        <div class="tw-w-32 tw-text-left">
                          光検出（{{ alert.value ?? "-" }}
                          Lux）
                        </div>
                        <div class="tw-w-14"></div>
                        <div class="tw-w-32"></div>
                      }
                    } @else {
                      <!-- 幅を揃えるため、空要素を設ける -->
                      <div class="tw-w-32">アラート</div>
                      <div class="tw-w-24"></div>
                      <div class="tw-w-32"></div>
                    }
                  </div>

                  <div class="tw-flex-col tw-w-ful tw-ml-16">
                    <div>
                      検知: {{ alert.eventAt | date: "yyyy/MM/dd HH:mm:ss" }}
                    </div>
                    <div>
                      通知: {{ alert.reportedAt | date: "yyyy/MM/dd HH:mm:ss" }}
                    </div>
                  </div>
                </div>
              </button>
            }

            <!-- プリアラートの場合 -->
            @if (
              alert.status === "PreAlertMax" ||
              alert.status === "PreAlertMin" ||
              alert.status === "PreAlert"
            ) {
              <button
                class="tw-w-full tw-border-0 tw-bg-yellow-100"
                [ngClass]="{
                  'tw-font-bold tw-text-red-500': isSelectedAlert(alert),
                }"
                (mouseenter)="onMouseEnter($event)"
                (mouseleave)="onMouseLeave($event)"
                (click)="
                  selectedAlert(
                    alert,
                    alertsPerDevice.deviceName,
                    alertsPerDevice.deviceId
                  )
                "
              >
                <div class="tw-flex tw-items-center tw-h-12 tw-ml-8">
                  <div class="tw-w-ful">
                    <mat-icon>warning</mat-icon>
                  </div>
                  <div class="tw-flex tw-items-center tw-w-ful">
                    @if (alert.status === "PreAlertMax") {
                      <div class="tw-w-32">上限ワーニング:</div>
                      <div class="tw-w-32">
                        {{ alert.value | numeral: "0.0" }} {{ unit }}
                      </div>
                      <div class="tw-w-40">
                        （上限 {{ alert.threshold | numeral: "0.0" }}
                        {{ unit }}）
                      </div>
                    } @else if (alert.status === "PreAlertMin") {
                      <div class="tw-w-32">下限ワーニング:</div>
                      <div class="tw-w-32">
                        {{ alert.value | numeral: "0.0" }} {{ unit }}
                      </div>
                      <div class="tw-w-40">
                        （下限 {{ alert.threshold | numeral: "0.0" }}
                        {{ unit }}）
                      </div>
                    } @else {
                      <!-- 幅を揃えるため、空要素を設ける -->
                      <div class="tw-w-32">ワーニング</div>
                      <div class="tw-w-24"></div>
                      <div class="tw-w-32"></div>
                    }
                  </div>

                  <div class="tw-flex-col tw-w-ful tw-ml-16">
                    <div>
                      検知: {{ alert.eventAt | date: "yyyy/MM/dd HH:mm:ss" }}
                    </div>
                    <div>
                      通知: {{ alert.reportedAt | date: "yyyy/MM/dd HH:mm:ss" }}
                    </div>
                  </div>
                </div>
              </button>
            }
          </div>
        }
      </mat-expansion-panel>
    }
  }
</mat-accordion>
@if (alertList.length < 1 && !loading) {
  <div>対象期間内にアラートはありません。</div>
} @else if (alertList.length > 0 && filteredAlertList.length < 1 && !loading) {
  <div>対象範囲内にアラートはありません。</div>
}
